function store(itemKey, itemValue) {
  let value = itemValue
  if (typeof value === 'object') {
    value = JSON.stringify(value)
  }

  localStorage.setItem(itemKey, value)
}

function storeEncoded(itemKey, itemValue) {
  let value = itemValue
  if (typeof value === 'object') {
    value = JSON.stringify(value)
  }

  let encryptedValue = Buffer.from(value, 'utf8').toString('base64')
  localStorage.setItem(itemKey, encryptedValue)
}

function get(itemKeyName) {
  let data = localStorage.getItem(itemKeyName)

  if (!data) {
    throw new Error(`No item found with key name of ${itemKeyName}`)
  }

  if (data.startsWith('{') || data.startsWith('[')) {
    data = JSON.parse(data)
  }

  return data
}

function getOrNull(itemKeyName) {
  let data = null

  try {
    data = get(itemKeyName)
  } catch (err) {
    return null
  }

  return data
}

function getEncoded(itemKeyName, throwError = true) {
  let data = localStorage.getItem(itemKeyName)
  let item = null

  if (!data && throwError) {
    throw new Error(`No item found with key name of ${itemKeyName}`)
  }

  item = data && Buffer.from(data, 'base64').toString('utf8')

  if (item?.startsWith('{') || item?.startsWith('[')) {
    item = JSON.parse(item)
  }

  return item
}

function remove(itemKeyName) {
  localStorage.removeItem(itemKeyName)
}

function removeEncoded(itemKeyName) {
  localStorage.removeItem(itemKeyName)
}

export default {
  get,
  getEncoded,
  getOrNull,
  remove,
  removeEncoded,
  store,
  storeEncoded,
}
